export const DEFAULT_ROW_ID = 'unsaved_row';

export const TRANSACTION_BATCH_STATUSES = {
  SAVED: 'Saved',
  UNPOSTED: 'Unposted',
  POSTING: 'Posting',
  POSTED: 'Posted',
  FAILED: 'Failed',
};
